class DataObject {
  static from(data) {
    return new this(data);
  }
}

export default DataObject;
